import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { StoreCache } from '@/modules/cache/store'
import { NAMA } from '@/modules/nama/main'

const cache = new StoreCache('inspection')

let res0, res1, res2, res3
const p0 = new Promise(res => res0 = res)
const p1 = new Promise(res => res1 = res)
const p2 = new Promise(res => res2 = res)
const p3 = new Promise(res => res3 = res)

export const storeReady = Promise.all([p0, p1, p2, p3])

export const useInspectionStore = defineStore('inspection', () => {
	const inspectors = ref(null)
	const inspections = ref(null)
	const inspection = ref(null)
	const namaGradeValues = ref(null)
	const namaGradeThresholds = ref(null)
	const bikeGradeValues = ref(null)
	const namaGrade = ref(null)
	const namaSplat = ref(null)
	const damageItems = ref([])
	const types = ref({
		1: 'NAMA Condition Check',
		2: 'Mechanical Inspection',
		6: 'Inspect & Collect',
		8: 'Check In/Out',
		9: 'HGV Inspection',
		10: 'LCV Inspection',
		11: 'Trailer Inspection',
	})

	cache.get('allInspectors').then(val => {
		res0()
		if (val === null) return
		inspectors.value = val
	})
	cache.get('allNamaGradeValues').then(val => {
		res1()
		if (val === null) return
		namaGradeValues.value = val
	})
	cache.get('allNamaGradeThresholds').then(val => {
		res2()
		if (val === null) return
		namaGradeThresholds.value = val
	})
	cache.get('allBikeGradeValues').then(val => {
		res3()
		if (val === null) return
		bikeGradeValues.value = val
	})

	const allInspectors = computed(() => inspectors.value)
	const allInspections = computed(() => inspections.value)
	const currentInspection = computed(() => inspection.value)
	const allNamaGradeValues = computed(() => namaGradeValues.value)
	const allNamaGradeThresholds = computed(() => namaGradeThresholds.value)
	const allBikeGradeValues = computed(() => bikeGradeValues.value)
	const currentNamaGrade = computed(() => namaGrade.value)
	const currentDamageItems = computed(() => damageItems.value)
	const inspectionTypes = computed(() => types.value)

	function setInspectors(newInspectors) {
		if (!(Array.isArray(newInspectors) || typeof newInspectors === 'object')) {
			return
		}

		cache.set(newInspectors, 'allInspectors')
		inspectors.value = newInspectors
	}

	function setInspections(newInspections) {
		if (!(Array.isArray(newInspections) || typeof newInspections === 'object')) {
			return
		}

		inspections.value = newInspections
	}

	function setCurrentInspection(newInspection) { 
		if (typeof newInspection !== 'object' && newInspection !== null) {
			return
		}

		inspection.value = newInspection
		
		if (inspection?.value?.damageitems) {
			damageItems.value = inspection.value.damageitems
		}
	}

	function setNamaGradeValues(newNamaGradeValues) {
		if (!(Array.isArray(newNamaGradeValues) || typeof newNamaGradeValues === 'object')) {
			return
		}

		cache.set(newNamaGradeValues, 'allNamaGradeValues')
		namaGradeValues.value = newNamaGradeValues
	}

	function setNamaGradeThresholds(newNamaGradeThresholds) {
		if (!(Array.isArray(newNamaGradeThresholds) || typeof newNamaGradeThresholds === 'object')) {
			return
		}

		cache.set(newNamaGradeThresholds, 'allNamaGradeThresholds')
		namaGradeThresholds.value = newNamaGradeThresholds
	}

	function setBikeGradeValues(newBikeGradeValues) {
		if (!(Array.isArray(newBikeGradeValues) || typeof newBikeGradeValues === 'object')) {
			return
		}

		cache.set(newBikeGradeValues, 'allBikeGradeValues')
		bikeGradeValues.value = newBikeGradeValues
	}

	function setNamaGrade(newNamaGrade) {
		if (typeof newNamaGrade !== 'string' && typeof newNamaGrade !== 'number') {
			return
		}

		namaGrade.value = newNamaGrade
	}

	function setDamageItems(newDamageItems) {
		if (Array.isArray(newDamageItems)) {
			damageItems.value = newDamageItems
			namaGrade.value = NAMA.grade(newDamageItems)
		}
	}

	return { 
		inspectors,
		inspections,
		inspection,
		namaGradeValues,
		namaGradeThresholds,
		bikeGradeValues,
		namaGrade,
		namaSplat,
		damageItems,
		types,
		allInspectors,
		allInspections, 
		currentInspection,
		allNamaGradeValues,
		allNamaGradeThresholds,
		allBikeGradeValues,
		currentNamaGrade,
		currentDamageItems,
		inspectionTypes,
		setInspectors,
		setInspections,
		setCurrentInspection,
		setNamaGradeValues,
		setNamaGradeThresholds,
		setBikeGradeValues,
		setNamaGrade,
		setDamageItems,
	}
})   